// AUTO-GENERATED by tools/measure-weight-ink.mjs — DO NOT hand-edit.
// Run `node tools/measure-weight-ink.mjs` whenever fonts are added or changed.
//
// Per-font vertical metrics for the WEIGHT LOCKUP, measured on "45LB" rather than on the words
// string `ink-offsets.js` uses. `ink` = the painted ink-centre's offset from the SVG
// `dominant-baseline:central` line, as a fraction of em (+ = ink sits ABOVE central).
// `cap` = the ink height of that line, also in em — what the ruled style places its rules off.
//
// 12 of 136 faces differ from the words measurement by >=2% of the font size:
// annie, cinzeldeco, girlnextdoor, labelle, lobster, lugrasimo, newrocker, pacifico, playfair, yanone, ysabeausc, zillaslab
export const WEIGHT_INK = Object.freeze({
  "abril": { ink: -0.035, cap: 0.678 },
  "alfaslab": { ink: 0.038, cap: 0.748 },
  "annie": { ink: 0, cap: 0.598 },
  "anton": { ink: 0, cap: 0.824 },
  "archivo": { ink: 0, cap: 0.662 },
  "archivoblack": { ink: -0.018, cap: 0.66 },
  "archivonarrow": { ink: -0.019, cap: 0.662 },
  "baloo": { ink: 0.026, cap: 0.588 },
  "bangers": { ink: 0.019, cap: 0.678 },
  "barlow": { ink: -0.05, cap: 0.676 },
  "barlowcond": { ink: -0.049, cap: 0.67 },
  "bbhbartle": { ink: 0, cap: 0.67 },
  "bebas": { ink: 0.05, cap: 0.672 },
  "bigshoulders": { ink: 0.016, cap: 0.772 },
  "blackops": { ink: 0.036, cap: 0.624 },
  "bodoni": { ink: 0.013, cap: 0.734 },
  "bowlby": { ink: 0.028, cap: 0.716 },
  "bowlbyone": { ink: 0.038, cap: 0.724 },
  "bungee": { ink: 0, cap: 0.688 },
  "bungeeshade": { ink: -0.061, cap: 0.814 },
  "cardo": { ink: 0.03, cap: 0.676 },
  "castorotitling": { ink: 0.095, cap: 0.686 },
  "caveat": { ink: -0.024, cap: 0.672 },
  "chakra": { ink: 0, cap: 0.676 },
  "changaone": { ink: -0.039, cap: 0.602 },
  "chango": { ink: -0.042, cap: 0.672 },
  "chivo": { ink: 0, cap: 0.662 },
  "cinzel": { ink: 0.043, cap: 0.682 },
  "cinzeldeco": { ink: -0.058, cap: 0.864 },
  "college": { ink: 0.012, cap: 0.664 },
  "collegebold": { ink: 0.013, cap: 0.658 },
  "collegecond": { ink: 0.013, cap: 0.662 },
  "collegesemi": { ink: 0.013, cap: 0.662 },
  "courgette": { ink: 0.027, cap: 0.714 },
  "courierprime": { ink: 0.07, cap: 0.56 },
  "dancing": { ink: 0, cap: 0.762 },
  "danfo": { ink: -0.043, cap: 0.686 },
  "dmsans": { ink: 0, cap: 0.676 },
  "dmserif": { ink: -0.024, cap: 0.636 },
  "dosis": { ink: -0.03, cap: 0.7 },
  "ebgaramond": { ink: -0.034, cap: 0.636 },
  "epilogue": { ink: 0.091, cap: 0.71 },
  "figtree": { ink: 0, cap: 0.674 },
  "firacond": { ink: 0, cap: 0.658 },
  "fjallaone": { ink: 0.038, cap: 0.8 },
  "fraunces": { ink: -0.012, cap: 0.684 },
  "fugaz": { ink: 0.046, cap: 0.688 },
  "germania": { ink: 0, cap: 0.65 },
  "girlnextdoor": { ink: 0.114, cap: 0.584 },
  "gloria": { ink: 0.016, cap: 0.784 },
  "goldman": { ink: 0, cap: 0.564 },
  "graduate": { ink: 0, cap: 0.73 },
  "greatvibes": { ink: 0.103, cap: 0.858 },
  "hanken": { ink: 0, cap: 0.67 },
  "inter": { ink: 0, cap: 0.7 },
  "jakarta": { ink: -0.036, cap: 0.72 },
  "josefin": { ink: 0.106, cap: 0.688 },
  "josefinslab": { ink: 0.097, cap: 0.678 },
  "jost": { ink: 0, cap: 0.672 },
  "kanit": { ink: -0.031, cap: 0.618 },
  "kaushan": { ink: -0.031, cap: 0.742 },
  "khand": { ink: 0.058, cap: 0.66 },
  "labelle": { ink: 0.2, cap: 0.696 },
  "leaguegothic": { ink: 0, cap: 0.704 },
  "lexend": { ink: -0.025, cap: 0.674 },
  "librebaskerville": { ink: 0.033, cap: 0.75 },
  "lilita": { ink: 0, cap: 0.666 },
  "lobster": { ink: -0.098, cap: 0.884 },
  "lora": { ink: -0.015, cap: 0.686 },
  "luckiestguy": { ink: 0, cap: 0.668 },
  "lugrasimo": { ink: 0, cap: 0.906 },
  "manrope": { ink: -0.024, cap: 0.696 },
  "marcellus": { ink: 0, cap: 0.692 },
  "michroma": { ink: -0.072, cap: 0.736 },
  "moderustic": { ink: -0.026, cap: 0.676 },
  "monoton": { ink: 0.025, cap: 0.79 },
  "montserrat2": { ink: 0, cap: 0.674 },
  "mulish": { ink: -0.026, cap: 0.68 },
  "newamsterdam": { ink: 0, cap: 0.624 },
  "newrocker": { ink: -0.065, cap: 0.886 },
  "nixie": { ink: -0.01, cap: 0.7 },
  "nunito": { ink: 0.023, cap: 0.678 },
  "ooohbaby": { ink: 0.034, cap: 0.684 },
  "orbitron": { ink: -0.024, cap: 0.696 },
  "oswald": { ink: -0.047, cap: 0.778 },
  "outfit": { ink: -0.019, cap: 0.678 },
  "overpass": { ink: 0.099, cap: 0.674 },
  "pacifico": { ink: 0, cap: 0.812 },
  "passionone": { ink: 0.024, cap: 0.592 },
  "pathwaygothic": { ink: -0.029, cap: 0.678 },
  "paytone": { ink: -0.071, cap: 0.658 },
  "permanentmarker": { ink: -0.041, cap: 0.674 },
  "playfair": { ink: -0.115, cap: 0.782 },
  "playwriteau": { ink: 0.036, cap: 0.976 },
  "pompiere": { ink: 0.059, cap: 0.77 },
  "poppins": { ink: 0.01, cap: 0.688 },
  "prata": { ink: 0.083, cap: 0.786 },
  "ptsansnarrow": { ink: -0.022, cap: 0.68 },
  "questrial": { ink: 0.026, cap: 0.644 },
  "quicksand": { ink: -0.027, cap: 0.666 },
  "racingsans": { ink: -0.027, cap: 0.61 },
  "rajdhani": { ink: 0.031, cap: 0.618 },
  "redhat": { ink: 0, cap: 0.676 },
  "reenie": { ink: 0.048, cap: 0.664 },
  "righteous": { ink: -0.014, cap: 0.672 },
  "roboto": { ink: 0, cap: 0.684 },
  "robotocond": { ink: 0, cap: 0.684 },
  "rowdies": { ink: -0.022, cap: 0.676 },
  "rozha": { ink: 0, cap: 0.548 },
  "rubik": { ink: 0, cap: 0.672 },
  "rubikmono": { ink: 0.037, cap: 0.666 },
  "rye": { ink: 0.012, cap: 0.736 },
  "sairacond": { ink: 0, cap: 0.66 },
  "sciencegothic": { ink: 0, cap: 0.672 },
  "shrikhand": { ink: 0.033, cap: 0.63 },
  "sigmar": { ink: -0.027, cap: 0.65 },
  "silkscreen": { ink: -0.075, cap: 0.602 },
  "sora": { ink: 0.023, cap: 0.706 },
  "spacegrotesk": { ink: 0, cap: 0.676 },
  "specialelite": { ink: 0.146, cap: 0.676 },
  "spectral": { ink: 0.031, cap: 0.642 },
  "squadaone": { ink: 0, cap: 0.626 },
  "staatliches": { ink: 0.024, cap: 0.668 },
  "teko": { ink: 0.081, cap: 0.618 },
  "tektur": { ink: 0, cap: 0.674 },
  "titanone": { ink: -0.04, cap: 0.676 },
  "tuffy": { ink: -0.047, cap: 0.682 },
  "ultra": { ink: 0, cap: 0.69 },
  "urbanist": { ink: 0, cap: 0.676 },
  "worksans": { ink: -0.013, cap: 0.638 },
  "yanone": { ink: 0.043, cap: 0.714 },
  "yellowtail": { ink: 0, cap: 0.676 },
  "yeseva": { ink: 0.015, cap: 0.69 },
  "ysabeausc": { ink: -0.108, cap: 0.72 },
  "zendots": { ink: 0.027, cap: 0.69 },
  "zillaslab": { ink: -0.076, cap: 0.724 },
});

/** Vertical ink-centre offset (em) for a weight lockup in `fontId`. 0 when unmeasured. */
export function weightInk(fontId) {
  const m = WEIGHT_INK[fontId];
  return m && Number.isFinite(m.ink) ? m.ink : null;
}

/** Ink height (em) of a weight lockup in `fontId`. null when unmeasured. */
export function weightCap(fontId) {
  const m = WEIGHT_INK[fontId];
  return m && Number.isFinite(m.cap) && m.cap > 0 ? m.cap : null;
}
